import { PartnerApiUrls } from "./api-urls";
import axios from "axios";
import globalVariables from "../global-variables";


export const GetPartnerCategoryList = (p_request_object, p_success_function,navigate) => {
	
    //Get partner category List
	axios.post(globalVariables.variables.strApiUrl + PartnerApiUrls.get_partner_category_having_partners_api, p_request_object)
	.then((response_list) => {
		if(response_list.data === 'error')
		{
			navigate('/error-page')
		}
		else
		{
			// pass the result in the success function of the respective page
			p_success_function(response_list.data[0]);
		}
	});

};
export const GetPartnerList = (p_request_object, p_success_function,navigate) => {
	
    //Get partner List
	axios.post(globalVariables.variables.strApiUrl + PartnerApiUrls.get_partner_api, p_request_object)
	.then((response_list) => {
		if(response_list.data === 'error')
		{
			navigate('/error-page')
		}
		else
		{
			// pass the result in the success function of the respective page
			p_success_function(response_list.data[0]);
		}
	});

};
